<template>
  <div class="modal fade modal-terms-conditions" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Terms and Conditions for Carriers ({{ publishedDecorated.version }})</h4>
        </div>
        <div class="modal-body">
          <p class="lead">
            Last updated: {{ publishedDecorated.formatted_published_at }}
            <span class="m-l-lg" v-if="userHasAcceptedTerms">
              Accepted at: {{ authorized.agreed_on }}
            </span>
          </p>
          <div class="content" v-html="publishedDecorated.content">
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="userHasAcceptedTerms" type="button" class="btn btn-info" data-dismiss="modal">Close</button>

          <template v-else>
            <ladda-button type="danger" :on-click="handleDoNotAcceptTerms">Don't Accept</ladda-button>
            <ladda-button type="success" :on-click="handleAcceptTerms">Accept</ladda-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Roles } from 'utils/user'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { LaddaButton } from 'components/forms'
  import $ from 'jquery'
  import moment from 'moment'

  export default {
    components: {
      LaddaButton
    },

    computed: {
      ...mapGetters('terms', { publishedDecorated: 'published' }),

      ...mapState('terms', ['published']),

      ...mapGetters('user', ['authorized', 'user']),

      /**
       * Determine if user has accepted the terms.
       *
       * @return boolean
       */
      userHasAcceptedTerms () {
        return (this.published.id === null || this.published.id === undefined) ||
          (this.authorized.agreed_on !== null && moment(this.user.agreed_on).isAfter(this.published.published_at))
      },

      /**
       * Determine if user has not accepted the terms.
       *
       * @return boolean
       */
      userHasNotAcceptedTerms () {
        return !this.userHasAcceptedTerms
      }
    },

    created () {
      this.fetchAndShowTermsAndConditions()

      this.$bus.$on('refreshTermsAndConditions', this.fetchAndShowTermsAndConditions)
    },

    beforeDestroy () {
      this.$bus.$off('refreshTermsAndConditions', this.fetchAndShowTermsAndConditions)
    },

    methods: {
      ...mapActions('terms', ['getPublishedTerm', 'acceptPublishedTerm']),
      ...mapActions('user', ['authorize']),

      /**
       * Refresh the terms and conditions.
       *
       * @return void
       */
      fetchAndShowTermsAndConditions () {
        this.getPublishedTerm().then(this.automaticallyShowIfNotAccepted)
      },

      /**
       * Close the modal.
       *
       * @return void
       */
      close () {
        $(this.$el).modal('hide')
      },

      /**
       * Handle accepting the terms.
       *
       * @return Promise
       */
      handleAcceptTerms () {
        return this.acceptPublishedTerm()
          .then(this.authorize)
          .then(this.close)
      },

      /**
       * Handle rejecting the terms.
       *
       * @return Promise
       */
      handleDoNotAcceptTerms () {
        return Promise.resolve()
          .then(this.close)
          .then(() => {
            this.$router.push({ name: 'auth.logout' })
          })
      },

      /**
       * Automatically show the terms if the user has not accepted.
       *
       * @return void
       */
      automaticallyShowIfNotAccepted () {
        if (this.authorized.role_id === Roles.CARRIER && this.userHasNotAcceptedTerms) {
          this.$nextTick(() => {
            $(this.$el).modal('show')
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TermsAndConditions.vue?157ef8d9